import { Component } from '@angular/core';

import { take, takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { SingleDetailComponent } from 'app/shared/components/single-detail/single-detail.component';
import { IClientAccountDetailsModel } from 'app/shared/models/client-account.models';
import { ClientAccountService } from 'app/shared/services/client-account.service';

import { ScannedDetailsComponentBase } from '../ScannedDetailsComponentBase';

@Component({
  selector: 'app-scanned-account-details',
  templateUrl: './scanned-account-details.component.html',
  styleUrls: ['./scanned-account-details.component.scss'],
  standalone: true,
  imports: [SingleDetailComponent],
})
export class ScannedAccountDetailsComponent extends ScannedDetailsComponentBase {
  public clientAccountDetails: IClientAccountDetailsModel;

  constructor(private clientAccountService: ClientAccountService) {
    super();
  }

  handleCodeScanned(): void {
    this.clientAccountService
      .getClientAccountDetailsByLabelCodeV1(this.labelCode.identifier)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (clientAccountDetails: IClientAccountDetailsModel) => {
          this.clientAccountDetails = clientAccountDetails;
          this.navigationInstructions.emit(['/client-accounts', clientAccountDetails.id]);
        },
        error: (_error) => this.handleScanFail(),
      });
  }
}
